module.exports = new __parcel__URL__("ConfluenceStandardOfferCalendarModalRightSideDark.315b1cd5.svg").toString();